import React from 'react';
import ARIUser from './containers/ARIUser';

export default ARIUser;

export { uiDataARIUser, serverDataARIUser } from './reducers/ARIUser';

